import React, { createContext, useContext, useCallback, useState } from "react";

interface AprovacaoNotificationsContextType {
  refreshNotifications: () => void;
  setRefreshFunction: (fn: () => void) => void;
}

const AprovacaoNotificationsContext = createContext<AprovacaoNotificationsContextType | undefined>(
  undefined,
);

export function AprovacaoNotificationsProvider({ children }: { children: React.ReactNode }) {
  const [refreshFunction, setRefreshFunction] = useState<(() => void) | null>(null);

  const refreshNotifications = useCallback(() => {
    if (refreshFunction) {
      refreshFunction();
    }
  }, [refreshFunction]);

  const setRefreshFunctionCallback = useCallback((fn: () => void) => {
    setRefreshFunction(() => fn);
  }, []);

  return (
    <AprovacaoNotificationsContext.Provider
      value={{
        refreshNotifications,
        setRefreshFunction: setRefreshFunctionCallback,
      }}
    >
      {children}
    </AprovacaoNotificationsContext.Provider>
  );
}

export function useAprovacaoNotificationsContext() {
  const context = useContext(AprovacaoNotificationsContext);
  if (context === undefined) {
    throw new Error(
      "useAprovacaoNotificationsContext must be used within an AprovacaoNotificationsProvider",
    );
  }
  return context;
}
